import type { Reference, Side } from '@ps/web-martech-cms-types';
import { ContentType } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSReference } from '@swf/cms';

import styles from './CMSSide.scss';

const CMSSide: React.FC<Side> = ({ body }) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {body.map((item, index) => {
      const [sideContent] = Object.values(item);
      return sideContent.reference.map((ref: Reference, index: number) => (
        <React.Fragment key={index}>
          {ref._content_type_uid === ContentType.SideRelatedContent && (
            <div className={styles.separator} />
          )}
          <CMSReference {...ref} />
        </React.Fragment>
      ));
    })}
  </>
);

export default CMSSide;
